import { ele } from "cables-shared-client";
import api from "../../api.js";
import web from "../../index.js";
import PatchLists from "../../patchlists.js";

export default class PageUser
{
    constructor(targetElement)
    {
        // (targetEl, userId, username, avatarId, sandboxUrl)
        const userId = targetElement.dataset.userid;
        const username = targetElement.dataset.username;
        const avatarId = targetElement.dataset.avatarid;
        const sandboxUrl = targetElement.dataset.sandboxurl;

        this.projects = web.projects;
        this.patchLists = new PatchLists();

        let url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o");

        if (avatarId)
        {
            web.embedPatch({
                "projectId": avatarId,
                "elementId": "canvascontainer",
                "sandboxUrl": sandboxUrl
            }, (error) =>
            {
                const errorEl = document.getElementById("errorEl");
                const canvasContainer = document.getElementById("canvascontainer");
                if (canvasContainer) canvasContainer.style.display = "none";
                if (errorEl)
                {
                    errorEl.style.display = "block";
                    const msg = errorEl.querySelector(".errorMessage");
                    msg.innerText = error.msg;
                }
            });
        }

        ele.byId("nav-bar").style.marginBottom = "0";
        this.projects.getUserProjects(userId, false, limit, offset);

        let followBtn = document.getElementById("follow-button");
        if (followBtn)
        {
            followBtn.addEventListener("click", (ev) =>
            {
                ev.preventDefault();
                web.favs.follow(userId);
            });
        }

        this.initFeaturedPatches(username);
        this.initLikedPatches(username);
    }

    initFeaturedPatches(username)
    {
        let url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o");

        ele.byId("nav-bar").style.marginBottom = "0";
        this.getUserFeatured(username, limit, offset);
    }

    initLikedPatches(username)
    {
        let url = new URL(window.location.href);
        let limit = url.searchParams.get("l") || 48;
        let offset = url.searchParams.get("o");

        ele.byId("nav-bar").style.marginBottom = "0";
        this.getUserLikes(username, limit, offset);
    }

    getUserFeatured(username, limit, offset = 0)
    {
        limit = Number(limit);
        offset = Number(offset);
        let url = "user/featured/" + username;
        if (limit || limit === 0)
        {
            url += "?l=" + limit;
        }
        if (offset)
        {
            url += "&o=" + offset;
        }

        api.get(url, (result) =>
        {
            let html = "";
            for (const i in result.projects)
            {
                const project = result.projects[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername } });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }

            ele.byId("featured_projects").innerHTML = html;

            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId("featured_results_container"), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "";
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "?l=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&o=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch;
                });
            }
        });
    }

    getUserLikes(username, limit, offset = 0)
    {
        limit = Number(limit);
        offset = Number(offset);
        let url = "user/favs/" + username;
        if (limit || limit === 0)
        {
            url += "?l=" + limit;
        }
        if (offset)
        {
            url += "&o=" + offset;
        }

        api.get(url, (result) =>
        {
            let html = "";
            for (const i in result.projects)
            {
                const project = result.projects[i];
                const projectInfo = web.getHandleBarHtml("project_info", { "project": project, "user": { "_id": project.userId, "username": project.cachedUsername } });
                html += web.getHandleBarHtml("project", { "project": project, "projectInfo": projectInfo });
            }
            ele.byId("liked_projects").innerHTML = html;
            if (result.pagination)
            {
                web.tabs.initPagination(ele.byId("liked_results_container"), result.pagination, limit, offset, (newLimit, newOffset) =>
                {
                    let newSearch = "";
                    if (newLimit || newLimit === 0)
                    {
                        newSearch += "?l=" + newLimit;
                    }
                    if (newOffset)
                    {
                        newSearch += "&o=" + newOffset;
                    }
                    window.location = location.origin + location.pathname + newSearch + "#likes";
                });
            }
        });
    }
}
